import { JOB_APPLICATION_TAB } from 'src/constants/tabs';

const MAPPING: Record<string, JOB_APPLICATION_TAB> = {
  profile: JOB_APPLICATION_TAB.PROFILE,
  emails: JOB_APPLICATION_TAB.EMAILS,
  resume: JOB_APPLICATION_TAB.RESUME,
  'cover-letter': JOB_APPLICATION_TAB.COVER_LETTER,
  'selection-criteria': JOB_APPLICATION_TAB.SELECTION_CRITERIA,
  'previous-applications': JOB_APPLICATION_TAB.PREVIOUS_APPLICATIONS,
  'notes-attachments': JOB_APPLICATION_TAB.NOTES_ATTACHMENTS,
};

export const getTabFromQuery = (tab: string = ''): JOB_APPLICATION_TAB =>
  MAPPING[tab] || JOB_APPLICATION_TAB.RESUME;
